var render = function render(){var _vm=this,_c=_vm._self._c;return _c('enhanced-check',{attrs:{"id":_vm.fieldId,"name":_vm.fieldName,"rounded":false,"label":_vm.data.placeholder,"subClass":_vm.fieldClass,"disabled":_vm.disabled},model:{value:(_vm.fvalue),callback:function ($$v) {_vm.fvalue=$$v},expression:"fvalue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }